'use client';

import { FormControl } from '@/components/ui/formControl';
import { FormControlLabel } from '@/components/ui/formControlLabel';
import { Radio, RadioGroup } from '@/components/ui/radio';
import { productListSetSorting } from '@/features/products/state/list/actions';
import {
  useProductListActiveSortingOption,
  useProductListDispatch,
  useProductListSortingOptions
} from '@/features/products/state/list/context';
import { ProductsSortingOption } from '@/features/products/types/product';

interface ProductSortingOptionsProps {
  callback?: VoidFunction;
  setOptionWithoutChange?: (option: ProductsSortingOption) => void;
  chosenOptionWithoutChange?: ProductsSortingOption;
  className?: string;
}

export const ProductSortingOptions = ({
  callback,
  setOptionWithoutChange,
  chosenOptionWithoutChange,
  className = 'p-4'
}: ProductSortingOptionsProps) => {
  const dispatch = useProductListDispatch();
  const sortingOptions = useProductListSortingOptions();
  const activeSortingOption = useProductListActiveSortingOption();

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSortingValue: ProductsSortingOption = event.target.value as ProductsSortingOption;
    setOptionWithoutChange
      ? setOptionWithoutChange(newSortingValue)
      : dispatch(productListSetSorting({ sortingOption: newSortingValue }));
    if (callback) callback();
  };

  return (
    <div className={`flex flex-col grow ${className}`}>
      <FormControl>
        <RadioGroup
          aria-labelledby="sorting-radio-buttons-group-label"
          value={chosenOptionWithoutChange || activeSortingOption}
          name="sorting-radio-buttons-group"
          onChange={handleRadioChange}
        >
          {sortingOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              className="py-2"
              value={option.value}
              control={<Radio />}
              label={<p className="text-sm ml-1">{option.label}</p>}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};
